const messages = {
  title:
    "Tere tulemast Bridgestone <span class='text-danger'>PLUS</span> platformile",
  termsAndConditions: "Tingimused ja eeskirjad",
  accept: "Nõustu",
  decline: "Keeldu",
  dataModal:
    "Selle pakkumise kohandamiseks vastavalt teie huvidele palume teil lühidalt märkida oma tootehuvid ja tegevusvaldkonnad.",
  scrollToAccept: "Jätkamiseks nõustuge meie tingimustega, kerides allapoole",
  welcomeMessage: "Tere tulemast Bridgestone Plus'i",
  tailorOffer:
    "Selle pakkumise kohandamiseks vastavalt teie huvidele palume teil lühidalt märkida oma tootehuvid või tegevusvaldkonnad.",
  bussinessType:
    "Selle pakkumise kohandamiseks vastavalt teie huvidele palume teil lühidalt märkida oma tootehuvid või tegevusvaldkonnad.",
  selectAreas: "Valige palun järgmistest valdkondadest",
  multipleAnswers: "(mitu vastust on võimalik):",
  personalPreferences: "Isiklikud eelistused",
  carTyres: "Rehvid autodele, maasturitele ja tarbesõidukitele",
  motorcyclesTyres: "Rehvid mootorratastele",
  truckBusTyres: "Rehvid veoautodele ja bussidele",
  agricultureTyres: "Rehvid põllumajandussõidukitele",
  otrTyres: "OTR-rehvid",
  save: "Salvesta",
  businessRelationship: "Milline on teie ärisuhe Bridgestone'ga?",
  selectRelationship: "Valige palun*:",
  tradingPartner: "Olen kaubanduspartner, kes...",
  tradingPartnerDirect: "... tellib otse Bridgestone'st",
  tradingPartnerIndirect: "... tellib kaudselt (näiteks hulgimüügi kaudu)",
  tradingPartnerBoth: "... tellib nii otse kui ka kaudselt",
  fleetResponsibleDirect: "Olen autopargi eest vastutav, kes...",
  fleetResponsibleIndirect:
    "... tellib kaudselt (kaubanduse või hulgimüügi kaudu)",
  fleetResponsibleBoth: "... tellib nii otse kui ka kaudselt",
  noBusinessRelationship:
    "<b>Mul ei ole ärisuhteid Bridgestone'ga </b>(ei otseseid ega kaudseid)",
  yourCustomerNumber: "Teie Bridgestone'i kliendinumber*:",
  enterCustomerNumber: "Sisestage oma kliendinumber",
  waitPersonalisedView:
    "Oodake hetk, teie isikupärastatud BRIDGESTONE PLUS vaade luuakse.",
  personalised: "ISIKUPÄRASTATUD",
  plusInfo: "Siit leiate teavet oma Plus-konto ja Plus-postkasti kohta.",
  continue: "Jätka",
  skip: "Jäta vahele",
  oneOfTwo: "1 / 2",
  openApps:
    "Saate avada rakendused, kuhu olete juba registreeritud. Samuti saate taotleda juurdepääsu teistele rakendustele, mis võivad teile asjakohased olla.",
  requiredFields:
    "Palun täitke kohustuslikud väljad: Tiitel, Eesnimi, Perekonnanimi",
  stage: "etapp",
  chooseOne: "(Valige vähemalt 1 lahter)",
  required: "*kohustuslikud väljad",
  lengthCsNumber: "Kliendinumbri pikkus: 6-10 numbrit",
  waitForAdminApproval:
    "Täname, et registreerusite programmi Bridgestone Plus Rewards jaoks. Vaatame praegu teie taotlust läbi. Kui teie taotlus on heaks kiidetud, saate kinnitusmeili.",
  selectTyres: "SECTOR OF ACTIVITY AND PROFILE",
};

export default {
  messages,
};
